import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-89a6d2b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-column-fluid" }
const _hoisted_2 = { class: "card mb-5 mb-xl-8" }
const _hoisted_3 = {
  key: 0,
  class: "card-header"
}
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_7 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_8 = {
  key: 0,
  style: {"height":"1500px"}
}
const _hoisted_9 = { colspan: "12" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { colspan: "12" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]

import { ref, onMounted, inject } from "vue";
import TimeShow from "@/components/TimeShow.vue";
import { useI18n } from "vue-i18n";
import TableFooter from "@/components/TableFooter.vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { Search } from "@element-plus/icons-vue";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import InjectKeys from "@/core/types/TenantGlobalInjectionKeys";
import BankInfoDetailModal from "../modal/BankInfoDetail.vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import phonesData from "@/core/data/phonesData";

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentInformation',
  props: {
    partyId: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const isLoading = ref(true);
const deleteIndex = ref(-1);
const paymentInfos = ref(Array<any>());
const openConfirmBox = inject<any>(InjectKeys.OPEN_CONFIRM_MODAL);
const EditBankInfoRef = ref<any>(null);



const criteria = ref({
  page: 1,
  size: 20,
  infoKey: "",
  partyId: "",
});

const reset = () => {
  criteria.value.infoKey = "";
  fetchData(1);
};

onMounted(async () => {
  fetchData(1);
});

const refresh = () => {
  fetchData(1);
};

const fetchData = async (_page: number) => {
  isLoading.value = true;
  criteria.value.page = _page;

  if (props.partyId) {
    criteria.value.partyId = props.partyId;
  } else {
    criteria.value.partyId = "";
  }

  try {
    var res = await PaymentService.getPaymentInformation(criteria.value);
    criteria.value = res.criteria;
    paymentInfos.value = res.data;
  } catch (error) {
    console.log(error);
  } finally {
    isLoading.value = false;
  }
};

const openConfirmPanel = (_id: number) => {
  const _handler = () => PaymentService.deletePaymentInformation(_id);
  if (!_handler) {
    MsgPrompt.error(t("tip.fail"));
    return;
  }
  openConfirmBox(async () => {
    try {
      await _handler()
        .then(() => MsgPrompt.success())
        .then(() => {
          fetchData(criteria.value.page);
        });
    } catch (error) {
      MsgPrompt.error("聯繫 IT 人員");
    }
  });
};

const pageChange = (_page: number) => {
  fetchData(_page);
};

const showEditModal = (_item: any) => {
  EditBankInfoRef.value.show(_item);
};

const getPaymentCategory = (item: any) => {
  const code = item?.info?.bankCountry;
  if (!code) return "USDT";
  const entry = phonesData[code.toLowerCase?.() || code.toLowerCase()];
  if (!entry?.name) return "USDT";
  return `${entry.name} ${t("fields.theBank")}`;
};

const showViewModal = (_item: any) => {
  EditBankInfoRef.value.showReadonly(_item);
};

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_UserInfo = _resolveComponent("UserInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!props.partyId)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: criteria.value.infoKey,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.infoKey) = $event)),
                placeholder: "Search Bank Info",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (fetchData(1)), ["enter"]))
              }, {
                append: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    icon: _unref(Search),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (fetchData(1)))
                  }, null, 8, ["icon"])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                class: "ms-5",
                onClick: reset
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Reset")
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_7, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.id")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.category")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.details")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.updatedOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_9, [
                    _createVNode(ScaleLoader)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && paymentInfos.value.length === 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t("tip.nodata")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (!isLoading.value && paymentInfos.value.length != 0)
            ? (_openBlock(), _createBlock(_TransitionGroup, {
                key: 2,
                tag: "tbody",
                name: "table-delete-fade",
                class: "table-delete-fade-container text-gray-600 fw-semibold"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentInfos.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item,
                      class: _normalizeClass({ 'table-delete-fade-active': index === deleteIndex.value })
                    }, [
                      _createElementVNode("td", _hoisted_12, [
                        _createVNode(_component_UserInfo, {
                          url: "#",
                          name: item.partyName,
                          email: item.email,
                          partyId: item.partyId,
                          class: "me-2"
                        }, null, 8, ["name", "email", "partyId"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(getPaymentCategory(item)), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-light btn-primary btn-sm",
                          onClick: ($event: any) => (showViewModal(item))
                        }, _toDisplayString(_ctx.$t("action.viewDetails")), 9, _hoisted_13)
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.updatedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          class: "btn btn-light btn-success btn-sm me-3",
                          onClick: ($event: any) => (showEditModal(item))
                        }, _toDisplayString(_ctx.$t("action.edit")), 9, _hoisted_14),
                        _createElementVNode("button", {
                          class: "btn btn-light btn-danger btn-sm",
                          onClick: ($event: any) => (openConfirmPanel(item.id))
                        }, _toDisplayString(_ctx.$t("action.delete")), 9, _hoisted_15)
                      ])
                    ], 2))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(TableFooter, {
          onPageChange: pageChange,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(BankInfoDetailModal, {
      ref_key: "EditBankInfoRef",
      ref: EditBankInfoRef,
      onRefresh: refresh
    }, null, 512)
  ]))
}
}

})